import {Injectable} from "@angular/core";
import {RequesterService} from "../../../../shared/services/requester/requester.service";
import * as fromStore from '../../../../store';
import {Store} from "@ngrx/store";
import {DbStoreState} from '../../../../store';
import {BehaviorSubject, Observable} from "rxjs";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {map} from "rxjs/operators";
import mockData from "../../../../../assets/json/mock-data.json";

@Injectable({
  providedIn: 'root'
})
export class ResellerApiService {

  private currentWorkspaceId: any;
  private ownerWorkspaceId: any;
  private currentWorkspaceRoleId: any;

  constructor(
    private _requester: RequesterService,
    private _store: Store<DbStoreState>,
  ) {
    this._store.select(fromStore.getWorkspaceIdEntities).subscribe(workspaceIdEntities => {
      this.currentWorkspaceRoleId = workspaceIdEntities.currentWorkspaceRoleId;
      this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
    });
  }

  public addWebhook(webhookUrl: string) {
    const data = {
      webhook_url: webhookUrl
    };
    return this._requester.core
      .post(`workspaces/${this.currentWorkspaceId}/reseller/add-webhook-url`, null, data);
  }

  public generateApiKey() {
    return this._requester.core
      .post(`workspaces/${this.currentWorkspaceId}/reseller/api-key/generate`, null, null);
  }

  public getResellerClientData(useMockData = false) {
    if (useMockData) {
      const response: any = mockData['client-data'];
      return new BehaviorSubject<DbResponse>(response);
    }
    return this._requester.core
      .get(`workspaces/${this.currentWorkspaceId}/reseller/client-data`, null, true);
  }

  public getWordpressPlugins(searchTerm: string): Observable<DbResponse> {
    const params: any = {
      action: 'query_plugins',
      timeout: 15,
      request: {
        search: searchTerm || '',
        browse: !searchTerm ? 'popular' : '',
        per_page: 15,
        page: 1,
        fields: {
          sections: false,
          icon: true,
          short_description: true,
          homepage: true,
          ratings: true,
          requires: true,
          downloaded: true,
          tags: false,
          donate_link: false,
          active_installs: true,
          reviews: true,
          icons: true
        }
      }
    };

    return this._requester.wordpress.jsonp('plugins/info/1.1/', params, false)
      .pipe(
        map((response: DbResponse) => {
          if (!response || !response.success) {
            return response;
          }

          const mappedResponse = new DbResponse();
          mappedResponse.success = true;
          mappedResponse.data = response.data.plugins.map(plugin => ({
            slug: plugin.slug,
            title: plugin.name,
            description: plugin.short_description,
            version: plugin.version,
            author: plugin.author,
            rating: plugin.rating,
            logo: plugin.icons && (plugin.icons["1x"] || plugin.icons.default || `https://ps.w.org/${plugin.slug}/assets/icon-256x256.png`),
            active_installs: plugin.active_installs,
            selected: false
          }));

          return mappedResponse;
        })
      );
  }


  public savePreinstalledPlugins(
    activePlugins: string,
    products: Array<{ slug: string; product_id?: string }>
  ) {
    const requestBody = {
      active_plugins: activePlugins,
      products // ✅ real array
    };

    return this._requester.core.post(
      `workspaces/${this.currentWorkspaceId}/reseller/client-package`,
      null,
      requestBody
    );
  }


  public getResellerMainDomain() {
    return this._requester.lxd
      .get(`workspaces/${this.currentWorkspaceId}/main-domain/get-client-main-domain`, null, true);
  }

  public addDomain(data) {
    return this._requester.lxd
      .post(`workspaces/${this.currentWorkspaceId}/main-domain/add-client-main-domain`, null, data);
  }

  public removeDomain() {
    return this._requester.lxd
      .delete(`workspaces/${this.currentWorkspaceId}/main-domain/delete`, null);
  }

  public troubleshootMainDomain() {
    return this._requester.lxd
      .post(`workspaces/${this.currentWorkspaceId}/main-domain/troubleshoot`, null);
  }

  public generateSLL() {
    return this._requester.lxd
      .post(`workspaces/${this.currentWorkspaceId}/main-domain/generate-certificate`, null);
  }
}
